import algoliasearch from 'algoliasearch';
import pkg from 'lodash';
import { useConfigStore } from '~/store/config';
import type { SellerClub, SellerPerson } from '~/constants/types/seller';
const { uniqBy } = pkg;

type algoliaQuery = {
  indexName: string,
  query: string,
  params?: {
    hitsPerPage: number,
  },
}

type AlgoliaClubResult = {
  hits: SellerClub[]
}

type AlgoliaSellerResult = {
  hits: SellerPerson[]
}

export default function useAlgoliaSearch() {
  const config = useConfigStore();
  const runtimeConfig = useRuntimeConfig();

  const client = algoliasearch(
    runtimeConfig.public.algoliaId,
    runtimeConfig.public.algoliaSecret
  );

  const algoliaClubSearch = async(input: string) => {
    const index = client.initIndex(`${config.algoliaBaseIndex}_groups`);
    const res = await index.search<AlgoliaClubResult>(
      `"${input}"`, // quotes for exact match only
      {
        typoTolerance: false,
      }
    );
    if (res) {
      return res.hits as SellerClub[];
    } else {
      console.error();
    }
    return [];
  };

  const algoliaSellerSearch = async(input: string) => {
    const index = client.initIndex(`${config.algoliaBaseIndex}_sellers`);
    const res = await index.search<AlgoliaSellerResult>(
      `"${input}"`,
      {
        typoTolerance: false,
      }
    );
    if (res) {
      return res.hits as SellerPerson[];
    } else {
      console.error();
    }
    return [];
  };

  const algoliaProductSearch = async(input: string) => {
    const index = client.initIndex(`${config.algoliaBaseIndex}_products`);
    client.clearCache();
    let output = [];

    await index
      .search(input, {
        hitsPerPage: 100,
      })
      .then((res) => {
        const { hits } = res;
        output = uniqBy(hits, 'centraVariant').flatMap((r: any) => {
          return (
            r.items?.map((i: any) => {
              return {
                ...r,
                name: `${r.title} - ${i.name}`,
              };
            }) ?? [r]
          );
        });
      });
    return output;
  };

  const algoliaMultipleQueries = async(input: algoliaQuery[]) => {
    return client.multipleQueries(input);
  };

  return {
    algoliaClubSearch,
    algoliaProductSearch,
    algoliaMultipleQueries,
    algoliaSellerSearch,
  };
}
